/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Twilio Message Status Values
 *
 * Source: https://www.twilio.com/docs/messaging/api/message-resource#message-status-values
 */
export var MessageStatus;

(function (MessageStatus) {
  MessageStatus["ACCEPTED"] = "accepted";
  MessageStatus["QUEUED"] = "queued";
  MessageStatus["SENDING"] = "sending";
  MessageStatus["SENT"] = "sent";
  MessageStatus["DELIVERED"] = "delivered";
  MessageStatus["UNDELIVERED"] = "undelivered";
  MessageStatus["FAILED"] = "failed";
  MessageStatus["RECEIVING"] = "receiving";
  MessageStatus["RECEIVED"] = "received";
  MessageStatus["SCHEDULED"] = "scheduled";
  MessageStatus["CANCELED"] = "canceled";
  MessageStatus["READ"] = "read";
  MessageStatus["PARTIALLY_DELIVERED"] = "partially_delivered";
})(MessageStatus || (MessageStatus = {}));